import { createContext, useContext } from 'react';

interface JotSupportHost {
  headerContainer: HTMLDivElement | null;
  setHeaderContainer: (element: HTMLDivElement | null) => void;
}

export const JotSupportHostContext = createContext<JotSupportHost | null>(null);

export function useJotSupportHost() {
  return useContext(JotSupportHostContext);
}
